import { FC } from 'react';
import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

import { Typography } from '@common/styles';

import { CircleProgressIcon } from './CircleProgressIcon';

interface Props {
  subject: string;
  reviews: {
    comment: string;
    percent: number;
  }[];
}

export const OneLineReviewItem: FC<React.PropsWithChildren<Props>> = ({ subject, reviews }) => {
  return (
    <Root>
      <Subject className={Typography.BODY_13_MEDIUM}>{subject}</Subject>
      <Reviews>
        {reviews.map((item, idx) => (
          <Review className={Typography.BODY_14_MEDIUM} key={idx}>
            <p dangerouslySetInnerHTML={{ __html: item.comment }} />
            <CircleProgressIcon percent={item.percent}>
              <Percent className={Typography.CAPTION_10_BOLD}>
                {item.percent}
                <span>%</span>
              </Percent>
            </CircleProgressIcon>
          </Review>
        ))}
      </Reviews>
    </Root>
  );
};

const Root = styled.li`
  display: flex;
  align-items: baseline;
  padding: 8px 0;
  border-bottom: 1px solid ${vars.v3Color.gray100};

  :first-child {
    padding-top: 0;
  }
  :last-child {
    padding-bottom: 0;
    border-bottom: 0;
  }
`;

const Subject = styled.p`
  width: 61px;
  margin-right: 12px;
  color: ${vars.v3Color.gray500};
`;

const Reviews = styled.ul`
  flex: 1;
`;

const Review = styled.li`
  display: flex;
  align-items: center;
  justify-content: space-between;
  line-height: 140%;
  color: ${vars.v3Color.gray600};
  border-bottom: 1px solid ${vars.v3Color.gray100};
  padding: 8px 0;

  :first-child {
    padding-top: 0;
  }
  :last-child {
    padding-bottom: 0;
    border-bottom: 0;
  }

  b {
    font-weight: 600;
    color: ${vars.v3Color.gray900};
  }
`;

const Percent = styled.p`
  position: absolute;
  height: 12px;
  top: 10px;
  bottom: 0;
  left: 0;
  right: 0;
  text-align: center;
  color: ${vars.v3Color.gray900};

  span {
    font-size: 7px;
  }
`;
